import {Component} from '@angular/core';

@Component({
  selector: 'app-background-crosses',
  templateUrl: './background-crosses.component.html'
})
export class BackgroundCrossesComponent {
}
